import { Component, OnInit, Input, ElementRef, ViewChild } from "@angular/core";
import { Components } from "@ionic/core";
import { ReportsService as reportService } from '../reports/reports.service';
import { ColumnMode, DatatableComponent, SelectionType } from "@swimlane/ngx-datatable";
import { StaffService as staffService } from "../staff/staff.service";
import { UserProfileStorageService } from '../services/user-profile-storage.service';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";
@Component({
  selector: 'available-reports',
  templateUrl: './available-reports.component.html',
  styleUrls: ['./available-reports.component.scss'],
})
export class AvailableReportsComponent implements OnInit {
  @Input() report;
  @Input() isCancel;
  @Input() modal: Components.IonModal;  
  @ViewChild(DatatableComponent, { static: false }) table: DatatableComponent;
  availableReports: any[] = [];
  staffId: any;
  allReports = [];
  public reportForm: FormGroup;
  loading = false; 
  Reports: any;  
  isConfirm = false;

  columns = [
    { name: 'Report Name' },
    { name: 'Scheduled On' },
    { name: 'Status' }
  ];

  constructor(private reportService: reportService,
    private staffService: staffService,
    private userProfileStorage: UserProfileStorageService
  ) { }

  ngOnInit() {
    console.log("report", this.report);
    this.fetchData();
  }

  get profile() {
    return this.userProfileStorage.profile;
  }

  getstaffidbyname() {
    return this.staffService.getStaffInfoByLoginName();
  }

  openReport(row) {
    console.log("This is row", row);
    var reportId = row.id;
    const reportObject = JSON.parse(row.reportObject);
    var staffAgency = reportObject.StaffAgency;
    var staffSchool = reportObject.StaffSchool;
    var ext = ".xlsx";

    if(reportObject.ReportName.includes("Student Attendance Audit Report")){
      ext = ".pdf"
    }

    this.reportService
      .getScheduleReport(reportId, staffAgency, staffSchool, ext)
      .subscribe((response: any) => {
        window.open(response.download);
      });
  }

  fetchData() {
    this.loading = true;

    this.getstaffidbyname().subscribe(
      (staffData: any) => {
        this.staffId = staffData;  // Assuming getstaffidbyname() sets this.staffId appropriately
        console.log("Staff data retrieved:", this.staffId);

        this.reportService.getScheduledReports(this.report.reportName).subscribe(
          (data: any) => {
            console.log("fetchData(): data from service:", data);

            if (this.staffId && this.staffId.staff && this.staffId.staff[0] && this.staffId.staff[0].staff) {
              this.availableReports = data.filter((report: any) =>
                report.staffId === this.staffId.staff[0].staff.id
              );
            } else {
              console.error("Error: staffId or staff information is missing.");
              this.availableReports = [];
            }
            this.loading = false;
          },
          (error) => {
            console.error("Error fetching attendance audit reports:", error);
            this.loading = false;
          }
        );
      },
      (error) => {
        console.error("Error fetching staff ID:", error);
        this.loading = false;
      }
    );
  }

}
